import styled from 'styled-components';
import { Steps as AntSteps } from 'antd';

export const Steps = styled(AntSteps)`
.ant-steps-item-container {
    pointer-events: none;
}
  .ant-steps-item-title {
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 18px;
    text-align: left;
    color: ${({theme}) => theme['black']};
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title{
    color:#000;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    background: ${({theme}) => theme['primary-color']};
    border: none;
}
.ant-steps-item-description {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #000000E0;
    padding-top: 2px;
}
.ant-steps-item-container{
  &:hover{
    .ant-steps-item-title {
    color: ${({theme}) => theme['black']} !important;
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title{
    color:#000 !important;;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    background: ${({theme}) => theme['primary-color']} !important;;
    border: none;
}
.ant-steps-item-title::after {
    background: ${({currentStep}) => currentStep >= 0 ? 'blue' : '#F0F0F0'} !important;;
    content: '';
}
  }
}

.ant-steps-item-finish .ant-steps-item-icon {
    background: green;
    border:none;
    span.ant-steps-icon {
    top: -4px;
    color: #fff;
}
}
.ant-steps-item-title::after {
    position: absolute;
    top: 8px;
    left: 100%;
    display: block;
    width: 9999px;
    height: 1px;
    background: ${({currentStep}) => currentStep >= 0 ? 'blue' : '#F0F0F0'};
    content: '';
}

`;
